'use client';

import { useTranslations } from 'next-intl';
import { Icon } from '@/lib/ui-kit/icons';
import { cn } from '@/lib/ui-kit/utils';
import { SECTION_ENTER_CLASS } from './motion';

interface NoResultsProps {
  query: string;
}

/** Nothing in any category (Figma "4.2 No results"). */
export function NoResults({ query }: NoResultsProps) {
  const t = useTranslations('search');
  return (
    <div
      className={cn(
        'my-auto flex flex-col items-center gap-1.5 px-4 py-6 text-center',
        SECTION_ENTER_CLASS,
      )}
    >
      <Icon name="Search" size={24} className="mb-1 text-v2-text-secondary" aria-hidden />
      <p className="text-[13px] font-semibold text-v2-text-primary [overflow-wrap:anywhere]">
        {t('noResultsFor', { query: query.trim() })}
      </p>
      <p className="text-[12px] leading-[1.4] text-v2-text-secondary">{t('noResultsHint')}</p>
    </div>
  );
}
